export enum QuestionType {
  ADDITION = 'ADDITION',
  SUBTRACTION = 'SUBTRACTION',
  MULTIPLICATION = 'MULTIPLICATION',
  DIVISION = 'DIVISION',
  STORY = 'STORY',
  FIND_OPERATOR = 'FIND_OPERATOR',
  EXPRESSION = 'EXPRESSION',
  HIDDEN_OPERAND = 'HIDDEN_OPERAND',
}

export enum ExpressionTypes {
  ARITHMETIC = 'ARITHMETIC',
  PATTERN = 'PATTERN',
  COUNTING = 'COUNTING',
  COMPARISON = 'COMPARISON',
  FRACTION = 'FRACTION',
  MONEY = 'MONEY',
  SHAPE = 'SHAPE',
}

export enum GameVariation {
  DIMENSION_2D = '2D',
  DIMENSION_3D = '3D',
  DIMENSION_2D_3D = '2D_3D',
  RELATIVE_POSITION_LINE = 'RELATIVE_POSITION_LINE',
  RELATIVE_POSITION_GRID = 'RELATIVE_POSITION_GRID',
}

export enum Operator {
  ADDITION = 'ADDITION',
  SUBTRACTION = 'SUBTRACTION',
  MULTIPLICATION = 'MULTIPLICATION',
  DIVISION = 'DIVISION',
  EQUAL_TO = 'EQUAL_TO',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN = 'GREATER_THAN',
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  COUNTING = 'COUNTING',
  ORDER_LIST = 'ORDER_LIST',
  NEARBY_NUMBERS = 'NEARBY_NUMBERS',
  SELECT_ITEMS = 'SELECT_ITEMS',
  SELECT_WRONG = 'SELECT_WRONG',
  MATCH_PAIRS = 'MATCH_PAIRS',
  IN_FRONT = 'IN_FRONT',
  BEHIND = 'BEHIND',
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  SMALLER = 'SMALLER',
  BIGGER = 'BIGGER',
  THINNER = 'THINNER',
  LONGER = 'LONGER',
}

export enum OperatorToken {
  ADDITION = '+',
  SUBTRACTION = '-',
  MULTIPLICATION = 'x',
  DIVISION = '/',
  EQUAL_TO = '=',
  LESS_THAN = '<',
  GREATER_THAN = '>',
  ASCENDING = 'ASC',
  DESCENDING = 'DESC',
  IN_FRONT = 'In front of',
  BEHIND = 'Behind',
  ABOVE = 'Above',
  BELOW = 'Below',
  LEFT = 'Left of',
  RIGHT = 'Right of',
  SMALLER = 'Smaller',
  BIGGER = 'Bigger',
  THINNER = 'Thinner',
  LONGER = 'Longer',
}

export enum OperatorName {
  EQUAL_TO = 'Is equal to',
  LESS_THAN = 'Is less than',
  GREATER_THAN = 'Is more than',
  IN_FRONT = 'Is in front of',
  BEHIND = 'Is behind',
  ABOVE = 'Is above',
  BELOW = 'Is below',
  LEFT = 'Is left of',
  RIGHT = 'Is right of',
  SMALLER = 'Is smaller than',
  BIGGER = 'Is bigger than',
  THINNER = 'Is thinner than',
  LONGER = 'Is longer than',
}

export enum FractionName {
  WHOLES = 'wholes',
  HALVES = 'halves',
  THIRDS = 'thirds',
  FOURTHS = 'fourths',
}

export enum questionTypeToken {
  'ADDITION' = '+',
  'SUBTRACTION' = '-',
  'MULTIPLICATION' = 'x',
  'DIVISION' = '/',
  'GREATER_THAN' = '>',
  'LESS_THAN' = '<',
  'EQUAL_TO' = '=',
}

export enum Operands {
  FIRST = 'A',
  SECOND = 'B',
  THIRD = 'C',
  OPERATOR = 'D',
}

export const GhanaianMoney = [
  { label: '1 pesewa', value: 0.01, img: '/img/1-pesewa.webp' },
  { label: '5 pesewas', value: 0.05, img: '/img/5-pesewa.webp' },
  { label: '10 pesewas', value: 0.1, img: '/img/10-pesewa.webp' },
  { label: '20 pesewas', value: 0.2, img: '/img/20-pesewa.webp' },
  { label: '50 pesewas', value: 0.5, img: '/img/50-pesewa.webp' },
  { label: '1 cedi', value: 1.0, img: '/img/1-cedis.webp' },
  { label: '2 cedis', value: 2.0, img: '/img/Money_2_GHS.webp' },
  { label: '5 cedis', value: 5.0, img: '/img/Money_5_GHS.webp' },
  { label: '10 cedis', value: 10.0, img: '/img/Money_10_GHS.webp' },
  { label: '20 cedis', value: 20.0, img: '/img/Money_20_GHS.webp' },
  { label: '50 cedis', value: 50.0, img: '/img/Money_50_GHS.webp' },
  { label: '100 cedis', value: 100.0, img: '100 cedis' },
  { label: '200 cedis', value: 200.0, img: '200 cedis' },
] as Money[]

export enum GameType {
  QUIZ = 'quiz',
  COUNT_ITEMS = 'count_items',
  ORDER_LIST = 'order_list',
  NUMBER_LINE = 'number_line',
  RELATIVE_POSITION = 'relative_position',
  SELECT_PATTERN = 'select_pattern',
  SELECT_SHAPE = 'select_shape',
  SELECT_IMAGE = 'select_image',
  MATCH_NUMBERS = 'match_numbers',
  MATCH_SHAPES = 'match_shapes',
  COUNTING = 'counting',
  PATTERN = 'pattern',
  ARITHMETIC = 'arithmetic',
  KAKOOMA = 'kakooma',
  KAKOOMA_FOUR_TO_ONE = 'kakooma_four_to_one',
  COMPARISON = 'comparison',
  FRACTION = 'fraction',
  MONEY = 'money',
  SHAPE = 'shape',
  DISTINGUISH_SHAPES = 'distinguish_shapes',
  DISTINGUISH_IMAGES = 'distinguish_images',
  IDENTIFY_SHAPES = 'identify_shapes',
  IDENTIFY_IMAGES = 'identify_images',
  REPRESENTATION_IMAGES = 'representation_images',
  POSITION = 'position',
  MEASUREMENT = 'measurement',
}

export enum HiddenOperands {
  OPERANDA = 'A',
  OPERANDB = 'B',
  OPERANDC = 'C',
}

export enum OperandVisualTypes {
  NUMBER = 'number',
  BLOCKS = 'blocks',
}

export enum ItemVisualTypes {
  ORANGES = 'oranges',
  BLOCKS = 'blocks',
  SHAPES = 'shapes',
  IMAGES = 'images',
  NUMBERS = 'numbers',
  MONEY = 'money',
}

export enum Shapes {
  CIRCLE = 'circle',
  SQUARE = 'square',
  TRIANGLE = 'triangle',
  RECTANGLE = 'rectangle',
  DIAMOND = 'diamond',
}

export enum Shapes2D {
  CIRCLE = 'circle',
  SQUARE = 'square',
  TRIANGLE = 'triangle',
  RECTANGLE = 'rectangle',
  HEXAGON = 'hexagon',
  PENTAGON = 'pentagon',
  OVAL = 'oval',
  HEART = 'heart',
  DIAMOND = 'diamond',
  CRESCENT = 'crescent',
  STAR = 'star',
}

export enum Shapes3D {
  SPHERE = 'sphere',
  CYLINDER = 'cylinder',
  CUBOID = 'cuboid',
  CUBE = 'cube',
  PYRAMID = 'pyramid',
  OCTAHEDRON = 'octahedron',
  PRISM = 'prism',
  CONE = 'cone',
  TETRAHEDRON = 'tetrahedron',
  DODECAHEDRON = 'dodecahedron',
}

export enum FractionShapes {
  CIRCLE = 'circle',
  SQUARE = 'square',
  TRIANGLE = 'triangle',
  RECTANGLE = 'rectangle',
  DIAMOND = 'diamond',
  RANDOM = 'random',
}

export enum FractionImages {
  BALL = '/img/games/position-ball.webp',
  BISCUIT = '/img/games/fraction-biscuit.webp',
  CHOCOLATE = '/img/games/fraction-chocolate.webp',
  SANDWICH = '/img/games/fraction-sandwich.webp',
  ORANGE = '/img/games/fraction-orange.webp',
  WAFFLE = '/img/games/fraction-waffle.webp',
  KITE = '/img/games/fraction-kite.webp',
  LEAF = '/img/games/fraction-leaf.webp',
  WATERMELON = '/img/games/fraction-watermelon.webp',
}

export const NUMBER_OF_LEVELS = 5
export const NUMBER_OF_RELIGION_LEVELS = 5

export enum roles {
  ADMIN = 'admin',
  TEACHER = 'teacher',
  STUDENT = 'student',
  GUARDIAN = 'guardian',
  SYSTEM_ADMIN = 'system_admin',
}

export enum Terms {
  FIRST = 'term-1',
  SECOND = 'term-2',
  THIRD = 'term-3',
}

export enum Classes {
  KG1 = 'KG1',
  KG2 = 'KG2',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  B4 = 'B4',
  B5 = 'B5',
  B6 = 'B6',
}

export enum Subjects {
  MATHEMATICS = 'mathematics',
  ENGLISH = 'english',
  SCIENCE = 'science',
}

export enum Strands {
  NUMBER = 'Number',
  ALGEBRA = 'Algebra',
  GEOMETRY = 'Geometry and Measurement',
  MEASUREMENT = 'Measurement',
  DATA = 'Data',
}

export enum PatternGameTypes {
  NEXT_PATTERN = 'next_pattern',
  WRONG_PATTERN = 'wrong_pattern',
}

export enum ComparisonGameTypes {
  ORDER_COMPARISON = 'order_comparison',
  ORDER_COMPARISON_WITH_SYMBOLS = 'order_comparison_with_symbols',
  DIFFERENCE_COMPARISON = 'difference_comparison',
}

export enum Direction {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  UP = 'UP',
  DOWN = 'DOWN',
}
